module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "doc-component",
    attrs: {
      "id": "button"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Botões")]), _vm._v(" "), _c('p', [_vm._v("O componente Botão possui interações de designer ao receber os eventos hover/focus e click/touch, ou seja, possui animações previamente pensadas, afim de indicar o comportamento realizado.")]), _vm._v(" "), _c('p', [_vm._v("Existem 2 componentes de botão com suas características já pré-definidas")]), _vm._v(" "), _c('div', {
    staticClass: "highlight-grid"
  }, [_c('p', [_c('round-button', [_vm._v("round-button")]), _vm._v(" "), _c('simple-button', [_vm._v("simple-button")])], 1), _vm._v(" "), _c('code', [_vm._v("\n      <round-button>round-button</round-button>\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', [_vm._v("\n      <simple-button>simple-button</simple-button>\n    ")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "highlight-grid"
  }, [_c('round-button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("button")]), _vm._v(" "), _c('round-button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("submit")]), _vm._v(" "), _c('simple-button', {
    attrs: {
      "type": "reset"
    }
  }, [_vm._v("reset")]), _vm._v(" "), _c('simple-button', {
    attrs: {
      "href": "http://www.moip.com.br"
    }
  }, [_vm._v("um link")]), _vm._v(" "), _c('round-button', {
    attrs: {
      "href": "http://www.moip.com.br"
    }
  }, [_vm._v("outro link")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Cores")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "highlight-grid"
  }, [_c('p', [_c('round-button', {
    attrs: {
      "href": "http://www.moip.com.br",
      "target": "_blank"
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('round-button', {
    staticClass: "pink",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("pink")]), _vm._v(" "), _c('round-button', {
    staticClass: "purple",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("purple")]), _vm._v(" "), _c('round-button', {
    staticClass: "green",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("green")]), _vm._v(" "), _c('round-button', {
    staticClass: "light-blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("light-blue")])], 1), _vm._v(" "), _c('code', [_vm._v("\n      <round-button class=\"pink\">pink</round-button>\n    ")]), _vm._v(" "), _c('p', [_c('simple-button', [_vm._v("default")]), _vm._v(" "), _c('simple-button', {
    staticClass: "pink",
    attrs: {
      "icon": "edit"
    }
  }, [_vm._v("pink")]), _vm._v(" "), _c('simple-button', {
    staticClass: "purple",
    attrs: {
      "icon": "edit"
    }
  }, [_vm._v("purple")]), _vm._v(" "), _c('simple-button', {
    staticClass: "green"
  }, [_vm._v("green")]), _vm._v(" "), _c('simple-button', {
    staticClass: "light-blue"
  }, [_vm._v("light-blue")])], 1), _vm._v(" "), _c('code', [_vm._v("\n      <simple-button class=\"pink\">pink</simple-button>\n    ")])]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Ocupando 100%")]), _vm._v(" "), _c('p', [_vm._v("Adicione a classe \"full\" para que o botão ocupe 100% do seu container")]), _vm._v(" "), _c('div', {
    staticClass: "highlight-grid"
  }, [_c('round-button', {
    staticClass: "full"
  }, [_vm._v("round-button 100%")]), _vm._v(" "), _c('code', [_vm._v("<round-button class=\"full\"></round-button>")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Ícones")]), _vm._v(" "), _c('p', [_vm._v("Adicione no seu componente o atributo \"icon\" com o nome do seu ícone")]), _vm._v(" "), _c('div', {
    staticClass: "highlight-grid"
  }, [_c('round-button', {
    staticClass: "pink",
    attrs: {
      "icon": "edit",
      "type": "submit"
    }
  }, [_vm._v("icon-edit")]), _vm._v(" "), _c('round-button', {
    staticClass: "purple",
    attrs: {
      "icon": "edit",
      "type": "submit"
    }
  }, [_vm._v("edit")]), _vm._v(" "), _c('simple-button', {
    staticClass: "pink",
    attrs: {
      "icon": "edit"
    }
  }, [_vm._v("icon-edit")]), _vm._v(" "), _c('simple-button', {
    staticClass: "purple",
    attrs: {
      "icon": "edit"
    }
  }, [_vm._v("edit")]), _vm._v(" "), _c('code', [_vm._v("\n      <round-button class=\"pink\" icon=\"edit\">icon-edit</round-button>\n    ")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Ícone de seta")]), _vm._v(" "), _c('p', [_vm._v("Adicione a classe \"arrow\"")]), _vm._v(" "), _c('div', {
    staticClass: "highlight-grid"
  }, [_c('p', [_c('round-button', {
    staticClass: "purple arrow",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("arrow")]), _vm._v(" "), _c('simple-button', {
    staticClass: "purple arrow"
  }, [_vm._v("arrow")])], 1), _vm._v(" "), _c('code', [_vm._v("\n      <round-button class=\"purple arrow\">arrow</round-button>\n    ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("O componente por default renderiza "), _c('code', [_vm._v("<button type=\"button\">")]), _vm._v(", podendo ser alterado direto no componente")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Caso queira um link "), _c('code', [_vm._v("<a>")]), _vm._v(", basta adicionar o atributo "), _c('code', [_vm._v("href")]), _vm._v(" no componente, conforme abaixo:")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Adicione a "), _c('b', [_vm._v("classe referente a cor")]), _vm._v(", lembrando que até o momento possuímos somente as cores abaixo listadas")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("A cor default é o azul, podendo variar entre as cores "), _c('code', [_vm._v("pink, purple, green, light-blue")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f4984ed!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Buttons.vue
// module id = 146
// module chunks = 1